import { Flex } from '@tremor/react';
import s from '@/pages/ConnectorInfo/ConnectorInfo.module.scss';
import { useConnectorAuth } from '@/hooks/useConnectorAuth';
import { ConnectorTitle } from '../ConnectorTitle/ConnectorTitle';
import { ConnectionSteps } from '@/components/ConnectionSteps/ConnectionSteps';
import { FACEBOOK_CONNECTION_STEPS } from '@/utils/constants';
import { ConnectorSubtitle } from '../ConnectorSubtitle/ConnectorSubtitle';
import { ConnectorRadioButton } from '../../Inputs/ConnectorRadioButton/ConnectorRadioButton';
import { BottomActions } from '../BottomActions/BottomActions';

const defaultValChecked = 'user-token';
export function FBInfoConnector() {
  const [setSelectedMethod, , isLoading, generateOAuthLink] = useConnectorAuth(
    defaultValChecked,
    {
      platform: 'facebook-ads',
      OAuthUrl: 'https://www.facebook.com/v17.0/dialog/oauth',
      clientID: import.meta.env._VITE_FB_APP_ID,
    },
  );

  return (
    <form
      className={s.form}
      onSubmit={async (e) => {
        e.preventDefault();
        window.location.href = await generateOAuthLink('ads_read,business_management');
      }}
    >
      <ConnectorTitle connectorId="facebook-ads">Facebook</ConnectorTitle>
      <ConnectionSteps
        style={{ marginBottom: '40px' }}
        steps={FACEBOOK_CONNECTION_STEPS}
        currentStep={1}
      />
      <ConnectorSubtitle>Choose how to connect with Facebook</ConnectorSubtitle>
      <Flex
        flexDirection="col"
        style={{ gap: '20px' }}
        onChange={(e) => setSelectedMethod((e.target as HTMLInputElement).value)}
      >
        <ConnectorRadioButton
          value="user-token"
          name="connector"
          label="Performance data access"
          defaultChecked
          description="Connect your historical performance data to fuel your reports"
        />
        <BottomActions isCreating={true} isLoading={isLoading} />
      </Flex>
    </form>
  );
}
